import { useRef, useState } from "react";
import dayjs from "dayjs";

import { CCheckbox } from "src/common/components/controls";
import { CPagination, CTable } from "src/common/components/others";

import { NCCModal } from "../NCCModal";

export const NCCTable = ({ data = [], loading, isSelectAll, onSelect }) => {
  //#region Data
  const [paginate, setPaginate] = useState({ page: 1, limit: 10 });

  const modalRef = useRef(null);
  //#endregion

  //#region Event
  const onPageChange = (_paginate) => setPaginate(_paginate);

  const select =
    (code = -1) =>
    (e) =>
      onSelect(code, e);

  const onPreview = (id) => () => modalRef.current.open(id);
  //#endregion

  //#region Render
  const fields = [
    // {
    //   key: "select",
    //   label: <CCheckbox value={isSelectAll} onChange={select()} />,
    //   sorter: false,
    // },
    {
      key: "code",
      label: "Mã NCC",
      _style: { minWidth: "220px", textAlign: "left" },
      sorter: false,
    },
    {
      key: "name",
      label: "Tên NCC",
      _style: { minWidth: "220px", textAlign: "left" },
      sorter: false,
    },
    {
      key: "reviewed",
      label: "Số Lần Đánh Giá",
      _style: { minWidth: "160px" },
      sorter: false,
    },
    {
      key: "created_date",
      label: "Ngày Tạo NCC",
      _style: { minWidth: "140px" },
      sorter: false,
    },
    {
      key: "materials",
      label: "Danh Sách NVL Cung Cấp",
      _style: { minWidth: "240px", textAlign: "left" },
      sorter: false,
    },
    {
      key: "address",
      label: "Địa Chỉ",
      _style: { minWidth: "180px", textAlign: "left" },
      sorter: false,
    },
    {
      key: "mobile",
      label: "Điện Thoại",
      _style: { minWidth: "130px" },
      sorter: false,
    },
    {
      key: "email",
      label: "Email",
      _style: { minWidth: "180px", textAlign: "left" },
      sorter: false,
    },
    {
      key: "note",
      label: "Ghi Chú",
      _style: { minWidth: "180px", textAlign: "left" },
      sorter: false,
    },
    {
      key: "active",
      label: "Trạng Thái",
      _style: { minWidth: "150px" },
      sorter: false,
    },
  ];

  const render = {
    select: ({ code, check }) => (
      <td>
        <CCheckbox value={check} onChange={select(code)} />
      </td>
    ),
    code: ({ code, id }) => (
      <td className="text-left">
        <span className="font-medium text-[#2752dd]" onClick={onPreview(id)}>
          {code}
        </span>
      </td>
    ),
    name: ({ name, id }) => (
      <td className="text-left">
        <span className="font-medium text-[#2752dd]" onClick={onPreview(id)}>
          {name}
        </span>
      </td>
    ),
    created_date: ({ created_date }) => (
      <td>{dayjs(created_date).format("DD/MM/YYYY")}</td>
    ),
    materials: ({ materials }) => (
      <td className="text-left">
        <p className="m-0 whitespace-pre-wrap">
          {(materials || []).map((e) => e.name).join(", ")}
        </p>
      </td>
    ),
    address: ({ address }) => <td className="text-left">{address}</td>,
    email: ({ email }) => <td className="text-left">{email}</td>,
    note: ({ note }) => <td className="text-left">{note}</td>,
    active: ({ active }) => (
      <td>
        {active ? (
          <span className="text-[#053C7F]">Đang cung cấp</span>
        ) : (
          <span className="text-[#C82D2A]">Ngưng cung cấp</span>
        )}
      </td>
    ),
  };

  return (
    <>
      <CTable
        // className="selectable"
        loading={loading}
        data={data}
        page={paginate.page}
        itemsPerPage={paginate.limit}
        fields={fields}
        render={render}
        footer={
          <CPagination
            page={paginate.page}
            total={data?.length}
            limit={paginate.limit}
            onPaginationChange={onPageChange}
          />
        }
      />

      <NCCModal ref={modalRef} />
    </>
  );
  //#endregion
};
